import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import useAuth from 'hooks/useAuth'
import { Button, Layer } from 'components'
import styles from './index.module.css'
import { useRecoilState } from 'recoil'
import { showMemberDropoutLayerState } from './states'
import Lib from 'library'
import { useNavigate, Link } from 'react-router-dom'
import ReceiptLayer from 'views/mydata/receipt/ReceiptLayer'
import { receiptLayerState } from 'views/mydata/receipt/states'

const MemberDropout = (outReason) => {

	const App = useApp()
	const Auth = useAuth()
	const navigate = useNavigate()
	const [showMemberDropOutLayer, setShowMemberDropoutLayer] = useRecoilState(showMemberDropoutLayerState)
	const [checked, setChecked] = useState(false)
	const [heDidIt, setHeDidIt] = useState(false)
	const [mdata, setMdata] = useState()
	const [thinkPoolPay, setThinkPoolPay] = useState(); // 씽크풀 결제 정보

	const [showReceiptLayer, setShowReceiptLayer] = useRecoilState(receiptLayerState)

	const onCheckClick = () => {
		setChecked(checked => setChecked(!checked))
	}

	const getData = () => {
		Lib.get(`/api/more/myinfo/mdataUseHist`, data => {
			//console.log('data : ' + JSON.stringify(data));
			let newData = {};
			if (Lib.isNotNull(data)) {
				newData = data;
			}
			else {
				newData = {
					totalCnt	:  0,
					stDe		: '',
					edDe		: ''
				};
			}
			setMdata(newData);
		})
	}

	// 씽크풀 결제정보 조회
	const getThinkPoolPayInfo = () => {
		Lib.post("/api/inner/thinkpool/payInfo", data => {
			//console.log('결제정보 : ' + JSON.stringify(data));
			setThinkPoolPay(data);
		})
	}

	const areYouSure = () => {
		//탈퇴 api 호출
		if (heDidIt) {
			App.closeAllLayers()
			navigate("/")
			App.setDidRun(false);
			Auth.setIsLogin(false);
		} else {
			let msg;	
			// 씽크풀 결제상태에 따른 메세지 분리 적용
			if (thinkPoolPay && thinkPoolPay.payYn === "Y") {
				msg = "탈퇴시 남아있는 유료결제 상품기간이 모두 사라져요! 정말로 탈퇴하시겠어요?<br/><br/>"
					+ "가입하신 상품: My Stock Manager<br/>"
					+ "가입일: " + ((thinkPoolPay && thinkPoolPay.payStartDate.length >= 10) ? thinkPoolPay.payStartDate.substring(0, 10).replace(/-/g, ".") : "") + "<br/>"
					+ "만료일: " + ((thinkPoolPay && thinkPoolPay.payEndDate.length >= 10) ? thinkPoolPay.payEndDate.substring(0, 10).replace(/-/g, ".") : "");
			} else {
				msg = "정말로 탈퇴하시겠어요?";
			}

			App.showAlert({
				msg: msg,
				confirm: true,
				type: "bottom",
				onOk: () => {
					App.showLoading()
					Lib.myPost({
						// 재판매모델 회원탈퇴 먼저 처리
						url: `/api/comm/user/whdwl/v1`,
						onSuccess: data => {
							console.log(data)
						},
						// onError: error => {
						// 	console.log('error>>>', error.response)
						// },
						onComplete: () => {
							// 기존 회원탈퇴 처리 추가
							Lib.post(`/api/more/myinfo/wthdr`, {
								mbWthdrRsn: outReason.outReason
							}, result => {
								App.user = {}
								window.localStorage.removeItem("mbId")
								window.localStorage.removeItem("useBio");
								// window.localStorage.removeItem("didRun")
								setHeDidIt(true)
								App.hideLoading();
							})
						},
					})
				}
			})
		}
	}

	const dataReceiptCheck = () => {
		//console.log("확인하기 눌렀음......")
		setShowReceiptLayer(true)
	}

	useEffect(() => {
		if (showMemberDropOutLayer === true) {
			getData();
			getThinkPoolPayInfo();
			setChecked(false);
		}
	}, [showMemberDropOutLayer])

	return (
		<Layer show={showMemberDropOutLayer} closeLayer={() => setShowMemberDropoutLayer(false)} right={heDidIt ? " " : undefined}>
			<div className="page">
				{
					mdata ?
						!heDidIt ?
							<>
								<div className="shadow">
									<div className="padding pb_50">
										<h3>탈퇴하기 전에 확인해주세요.</h3>
										<div className={`${styles["resign-guide"]} mt_40`}>
											<h4>개인정보 이용내역 안내</h4>
											<p className="mt_20">
												신용정보법 제18조의 6(본인신용정보관리회사의 행위규칙)에 따라 법령에 따른 통지의무사항으로 회원님의 개인정보 이용내역을 안내해드립니다. 자세한 내용은 데이터영수증으로 확인하시기 바랍니다.
											</p>
											{/* 마이데이터 연동 기간 및 건수 표시 */}
											<span className="mt_20">
												기간 : {mdata.stDe} ~ {mdata.edDe} 기준<br />
												건수 : {mdata.totalCnt}건{/*(서비스동의 {mdata.svcUseCnt}건, 데이터수집 {mdata.clctDataCnt}건)*/}
											</span>
										</div>
										<Button className="btn btn--big mt_30" onClick={dataReceiptCheck}>데이터 영수증 확인하기</Button>
									</div>
								</div>
								<div className="padding">
									<div className={styles["resign-box"]}>
										서비스 탈퇴시 관련법령에 의거하여 보존하는 최소한의 정보 이외에 이용자를 식별할 수 있는 모든 개인정보는 지체없이 삭제되고 데이터연동도 모두 철회됩니다. 또한 해당 정보는 향후 서비스 재가입시 복구할 수 없습니다.
									</div>
									<div className="chk mt_20" onClick={onCheckClick}>
										<i className={`checkMark ${checked === true ? "on" : ""}`} />
										<label htmlFor="check1">
											<span>안내사항을 모두 확인하였으며 동의합니다.</span>
										</label>
									</div>
									{checked ?
										<Button className="btn btn--big btn--dark mt_40" onClick={areYouSure}>탈퇴하기</Button>
										:
										<Button disabled={true} className="btn btn--big mt_40">탈퇴하기</Button>
									}
								</div>
							</>
							:
							<>
								<div className="flex_1 padding center-cont">
									<i className="icon icon_check_circle" />
									<h3 className="intro-tit mt_20">회원탈퇴가 완료되었어요.</h3>
									<p className="intro-sub-tit mt_10">그동안 이용해주셔서 감사합니다.</p>
								</div>
								<div className="padding flex-shrink_0">
									<Button className="btn btn--big" onClick={areYouSure}>확인</Button>
								</div>
							</>
						:
						""
				}
			</div>
			<ReceiptLayer />
		</Layer>
	)
}

export default MemberDropout
